import { graphql } from "gatsby";
import { PaginationBasic, PaginationDisabledActiveStates, PaginationSizing } from "../../../../src/examples/components/Pagination";
import * as React from 'react';
export default {
  graphql,
  PaginationBasic,
  PaginationDisabledActiveStates,
  PaginationSizing,
  React
};